import { Injectable } from '@angular/core';
import { CalltrackerService } from './calltracker.service';
import { UserSessionService } from '../usersession.service';
import { Router } from '@angular/router';
import { MailServerService } from '../mailServer.service';
import {AppService} from '../app.service';
import { IProspectMarketing } from '../../Shared/models/ProspectModel';


@Injectable({
    providedIn: 'root',
})
export class TwillioRCService {
    private baseURL = this.appService.config.apiBaseUrl;
    public selectedPhoneSystem = 0;
    marketingInfoPhone: IProspectMarketing;
    constructor(private router: Router,
      private userSessionService: UserSessionService, private callTrackerService: CalltrackerService, private appService: AppService) {
    }

    twilioCallEvent() {
        window.addEventListener('message', (e) => {
          const data = e.data;
           if (e.origin == "https://apps.ringcentral.com") {
            if (data) {
              switch (data.type) {
                case 'rc-call-ring-notify':
  
                  break;
                case 'rc-call-start-notify':
  
                  if (data.call.direction === 'Inbound') {
                    var sessionIdkey = localStorage.getItem('Inbound-sessionIdkey');
                    var fromNum = data.call.from;
                    var toUserName = data.call.toUserName;
                    if (fromNum) {
                      if (fromNum.startsWith("+1")) {
                        fromNum = fromNum.substring(2);
                      }
                    } else {
                      fromNum = '';
                    }
                    if (!toUserName) {
                      toUserName = '';
                    }
                    if (sessionIdkey !== data.call.partyData.sessionId) {
                        localStorage.setItem('Inbound-sessionIdkey', data.call.partyData.sessionId);
                        this.routeFromScreenPopup(fromNum, toUserName);
                    }
                }
                  // if (data.direction = 'Inbound') {
                  //   localStorage.removeItem('Inbound-sessionIdkey');
                  //   var fromNum = data.call.from;
                  //   var toUserName = data.call.toUserName;
                  //   if (fromNum) {
                  //     if (fromNum.startsWith("+1")) {
                  //       fromNum = fromNum.substring(2);
                  //     }
                  //   } else {
                  //     fromNum = '';
                  //   }
                  //   if (!toUserName) {
                  //     toUserName = '';
                  //   }
                  // }
                  break;
               case 'rc-call-end-notify':
                // get call on call end event
               // console.log(JSON.stringify(data))
               if (data.direction = 'Inbound') {
                let item = localStorage.getItem('calltracker');
                let ctData = JSON.parse(item);
                  if(ctData.CallRecordingId){
                     this.saveCallTrackerDetails(ctData);
                     this.userSessionService.resetCallTrackerSessionData();
                  }
                }
                 break;
                default:
                  break;
              }
            }
           }
        });

      }

      routeFromScreenPopup(number, firstName) {
        if (number.length === 11) {
          number = number.replace('+', '');
        } else if (number.length !== 10) {
          number = '';
        }
        this.GetCallSid(number, firstName);
      }

      GetCallSid(number, firstName) {
        //var sessionIdkey = localStorage.getItem('Inbound-sessionIdkey');
        this.callTrackerService.GetCallSid(number).subscribe((response: any) => {
          if (response) {
            var sid = '';
            var trackingNumber = '';
            if (response.CallSID) {
              sid = response.CallSID;
            }
            if (response.TrackingNumber) {
              trackingNumber = response.TrackingNumber;
            }
            let userID = 1;
            if(this.userSessionService.userSessionData.UserId && this.userSessionService.userSessionData.UserId!=0){
              userID = this.userSessionService.userSessionData.UserId;
            }
            const objCallTracker = {
              PhoneId: 0,
              OutboundCall: false,
              PhoneSystem: 467,
              CallDuration: 0,
              CallSID: sid,
              CallRecordingId: sid,
              TrackingNumber: trackingNumber,
              FacilityId: 0,
              PhoneNumber: number,
              AdSourceID: this.marketingInfoPhone && this.marketingInfoPhone.AdSourceListModel.length > 1 ? this.marketingInfoPhone.AdSourceListModel[0].Id: undefined,
              IncompleteCall: false,
              IncompleteCallUserId: userID,
              IncompleteCallConverted: false,
              IncompleteCallConvertedDatetime: new Date(),
              IncompleteCallConvertedUserId: userID
            }
            this.userSessionService.FillCallTrackerDetails(objCallTracker);
            number = (number.match(/\d/g) || []).slice(-10).join('');
            trackingNumber = trackingNumber && trackingNumber?.length < 10 ? trackingNumber.padStart(10, '0') : trackingNumber;
            const urlNavigate = '/prospect/screenpopup?phone='+number+'&firstName='+firstName+'&phoneCallSID='+sid+'&adPhone='+trackingNumber;
            this.router.navigate([]).then(result => {  window.open(urlNavigate, '_blank'); });
          }
        });
      }



      saveCallTrackerDetails(data) {
        var phoneCallsDetails;
        phoneCallsDetails = data;
        this.callTrackerService.SavePhoneCall(phoneCallsDetails).subscribe((response: any) => {
          if(response){
            this.UpdatePhoneCallDuration(phoneCallsDetails);
          }
        });
      }
      UpdatePhoneCallDuration(data) {
        const dataObj = {
          CallDuration: data.CallDuration,
          CallRecordingId: data.CallRecordingId,
          CallSId: data.CallSID,
        }

        this.callTrackerService.UpdatePhoneCallDuration(dataObj).subscribe((response: any) => {
          if(response){
            this.userSessionService.resetCallTrackerSessionData();
          }
        });
      }



}
